import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ToastService } from '@libs/shared-services';
import { ffdNotesRoutePrefix, routes } from '@libs/utils';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { getFfdNotesInvitationErrorKey } from '../../tokens/ffd-notes-invitation-error.util';
import { FfdNotesInvitationResolveService } from '../../tokens/ffd-notes-invitation-resolve.service';

@Component({
  selector: 'lib-ffd-notes-invite-welcome',
  imports: [TranslatePipe, RouterModule, SvgIconComponent, LottieComponent],
  templateUrl: './ffd-notes-invite-welcome.component.html',
  styleUrl: './ffd-notes-invite-welcome.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FfdNotesInviteWelcomeComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly resolveService = inject(FfdNotesInvitationResolveService);
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);

  protected readonly routes = routes;
  protected readonly ffdNotesRoutePrefix = ffdNotesRoutePrefix;
  protected readonly resolutionSignal = this.resolveService.resolutionSignal;
  protected readonly isLoadingSignal = signal(true);

  public readonly lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };

  public ngOnInit(): void {
    const code = this.activatedRoute.snapshot.queryParamMap.get('code');
    if (!code) {
      this.handleInvalidLink();
      return;
    }

    this.resolveService.setCode(code);
    this.resolveService.resolveCode$().subscribe({
      next: () => this.isLoadingSignal.set(false),
      error: (error) => this.handleInvalidLink(error),
    });
  }

  protected onContinue(): void {
    this.router.navigate([...ffdNotesRoutePrefix(), routes.baaSignupFlow, routes.baaSignupAccountDetails], {
      queryParamsHandling: 'preserve',
    });
  }

  private handleInvalidLink(error?: unknown): void {
    this.toastService.error(this.translateService.instant(getFfdNotesInvitationErrorKey(error)));
    this.router.navigate([...ffdNotesRoutePrefix(), routes.login]);
  }
}
